import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidationMessages } from '../validation-helper';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'md-form-control-error',
  template: '<span class="form-control-error" [hidden]="!message">{{message}}</span>'
})
export class FormControlErrorComponent implements OnInit, OnDestroy{

  @Input() formModel!: AbstractControl;

  public message: string = '';
  private destroyed: Subject<void> = new Subject();

  constructor() { }

  ngOnInit() {
    this.formModel.statusChanges.pipe(
      takeUntil(this.destroyed)
    ).subscribe(() => {
      this.message = ValidationMessages.get(this.formModel.errors).join(' ');
    });
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.unsubscribe();
  }

}
